import { StreamData } from 'types/streamData'
import { isRepost } from 'utils/postTypeUtil'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'
import dataStreamResolver from './dataStreamResolver'

const isRetweetResolver: FieldResolver = (metadata: Metadata) => {
  const { dataStream } = dataStreamResolver(metadata)
  return { isRetweet: isRepost(metadata.getPostType(), dataStream) } as StreamData
}

export default isRetweetResolver
